import { RelatedProductsModule } from 'src/app/mb/shared/components/related-products/related-products.module'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MbSearchBoxComponent } from '../shared/components/mb-search-box/mb-search-box.component'
import { MbSearchTopFiltersComponent } from './components/mb-search-top-filters/mb-search-top-filters.component'
import { MbSearchFiltersComponent } from './components/mb-search-filters/mb-search-filters.component'
import { MbSearchResultsHeaderComponent } from './components/mb-search-results-header/mb-search-results-header.component'
import { MbSearchResultsComponent } from './components/mb-search-results/mb-search-results.component'
import {
  ProductSearchAdapter,
  provideConfig,
  provideDefaultConfig,
  UrlModule
} from '@spartacus/core'
import {
  ActiveFacetsModule,
  FacetListModule,
  FacetModule,
  FacetService,
  IconModule,
  MediaModule,
  ProductFacetService,
  ProductListComponentService,
  SpinnerModule,
  ViewConfig
} from '@spartacus/storefront'
import { RouterModule } from '@angular/router'
import { MbSearchResultItemComponent } from './components/mb-search-results/mb-search-result-item/mb-search-result-item.component'
import { MbAddToCartModule } from '../cart/components/mb-add-to-cart/mb-add-to-cart.module'
import { DirectiveModule } from '../shared/directive.module'
import { ClipboardPopupModule } from '../shared/components/clipboard-popup/clipboard-popup.module'
import { ClipboardModule } from '@angular/cdk/clipboard'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { MbSearchResultsScrollComponent } from './components/mb-search-results/mb-search-results-scroll/mb-search-results-scroll.component'
import { MbSearchEmptyResultComponent } from './components/mb-search-empty-result/mb-search-empty-result.component'
import {
  MbSearchResultItemWrapperComponent
} from './components/mb-search-results/mb-search-result-item-wrapper/mb-search-result-item-wrapper.component'
import { MbFacetListComponent } from './components/mb-search-filters/mb-facet-list/mb-facet-list.component'
import { MbFacetComponent } from './components/mb-search-filters/mb-facet/mb-facet.component'
import { MbActiveFacetsComponent } from './components/mb-search-filters/mb-active-facets/mb-active-facets.component'
import { mbSearchRoutingConfig } from './config/mb-search-routing-config'
import { SafeHtmlModule } from '../cms/pipes/sanitize-html/safe-html.module'
import { MbProductListComponentService } from './services/mb-product-list-component.service'
import { MbProductFacetService } from './services/mb-product-facet.service'
import { MbFacetService } from './services/mb-facet.service'
import { SearchResultsModule } from '../cms/components/search-results/search-results.module'
import { AnalyticsModule } from '../analytics/analytics.module'
import { MbI18nModule } from '../translations/mb-i18n.module'
import { MbOccProductSearchAdapter } from './adapters'
import { customViewConfig } from './config/custom-view-config'

@NgModule({
  declarations: [
    MbSearchTopFiltersComponent,
    MbSearchFiltersComponent,
    MbSearchResultsHeaderComponent,
    MbSearchResultsComponent,
    MbSearchResultItemComponent,
    MbSearchResultsScrollComponent,
    MbSearchEmptyResultComponent,
    MbSearchResultItemWrapperComponent,
    MbFacetListComponent,
    MbFacetComponent,
    MbActiveFacetsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
    UrlModule,
    MbI18nModule,
    MediaModule,
    MbAddToCartModule,
    DirectiveModule,
    ClipboardPopupModule,
    ClipboardModule,
    SpinnerModule,
    InfiniteScrollModule,
    FacetListModule,
    ActiveFacetsModule,
    FacetModule,
    FacetListModule,
    SafeHtmlModule,
    SearchResultsModule,
    AnalyticsModule,
    RelatedProductsModule
  ],
  exports: [
    MbSearchResultsHeaderComponent,
    MbSearchResultsComponent,
    MbSearchFiltersComponent,
    MbSearchTopFiltersComponent,
    MbActiveFacetsComponent,
    MbSearchEmptyResultComponent
  ],
  providers: [
    {
      provide: ProductListComponentService,
      useExisting: MbProductListComponentService
    },
    {
      provide: ProductFacetService,
      useExisting: MbProductFacetService
    },
    {
      provide: FacetService,
      useExisting: MbFacetService
    },
    {
      provide: ProductSearchAdapter,
      useClass: MbOccProductSearchAdapter
    },
    provideDefaultConfig(mbSearchRoutingConfig),
    provideDefaultConfig(customViewConfig as ViewConfig),
    provideConfig({
      cmsComponents: {
        MiltenyiEmptySearchResultComponent: {
          component: MbSearchEmptyResultComponent
        },
        MiltenyiSearchForProductsComponent: {
          component: MbSearchBoxComponent
        },
        MiltenyiSearchTopFiltersComponent: {
          component: MbSearchTopFiltersComponent
        },
        MiltenyiSearchMoreFiltersComponent: {
          component: MbSearchFiltersComponent
        },
        MiltenyiSearchResultsHeaderComponent: {
          component: MbSearchResultsHeaderComponent
        },
        MiltenyiSearchResultsComponent: {
          component: MbSearchResultsComponent
        },
      }
    })
  ]
})
export class SearchModule {
}
